import { Button, Modal, Typography } from "antd";
import Flex from "../../../../../components/Flex";
import { CoverWizardForm } from "../CoverWizardModal";

export type SubmittedOrderModalPayload = {
  jobName: string;
  soNumber: string;
  isRga?: boolean;
  formData?: CoverWizardForm; // Add reference to the submitted CoverWizardForm data
};

const nonRgaParagraph =
  "Your files are in good hands, we're working behind the scenes to get your order done as quick as possible, and will reach out shortly with the next steps in the process.";
const rgaParagraph =
  "You're all set. We will reach out shortly with an email outlining the next steps in the return process.";

function getDisplayJobName(soNumber?: string, jobName?: string) {
  let ponum = soNumber;
  if (!ponum || ponum.trim() === "") {
    ponum = jobName ?? "";
  } else if (ponum && jobName) {
    ponum = `${ponum}\\${jobName}`;
  }
  return ponum.toUpperCase();
}

export function SubmittedOrderModal({
  submittedModalPayloadState: [submittedModalPayload, setSubmittedModalPayload],
}: {
  submittedModalPayloadState: [
    SubmittedOrderModalPayload | null,
    React.Dispatch<React.SetStateAction<SubmittedOrderModalPayload | null>>
  ];
}) {
  return (
    <Modal
      title={""}
      open={!!submittedModalPayload}
      footer={null}
      centered
      maskClosable={false}
      keyboard={false}
      onCancel={() => setSubmittedModalPayload(null)}
    >
      <Flex vertical style={{ padding: "16px" }}>
        <Typography.Title level={1} style={{ marginBottom: "10px" }}>
          All Done!
        </Typography.Title>
        <Flex gap="1rem" style={{ marginBottom: "10px" }}>
          {submittedModalPayload?.soNumber && (
            <Typography.Text>
              SO: {submittedModalPayload?.soNumber}
            </Typography.Text>
          )}
          {(submittedModalPayload?.soNumber ||
            submittedModalPayload?.jobName) && (
            <Typography.Text>
              Job Name:{" "}
              {getDisplayJobName(
                submittedModalPayload?.formData?.poNumber,
                submittedModalPayload?.formData?.jobName
              )}
            </Typography.Text>
          )}
        </Flex>
        <Typography.Paragraph italic style={{ marginBottom: "30px" }}>
          {submittedModalPayload?.isRga ? rgaParagraph : nonRgaParagraph}
        </Typography.Paragraph>
        <Button
          style={{
            height: "37px",
            width: "100px",
            borderRadius: "8px",
            alignSelf: "center",
          }}
          type="primary"
          onClick={() => {
            setSubmittedModalPayload(null);
          }}
        >
          Close
        </Button>
      </Flex>
    </Modal>
  );
}
